import { render, staticRenderFns } from "./NeoparentDashboardHome.vue?vue&type=template&id=dc38ed82&scoped=true"
import script from "./NeoparentDashboardHome.vue?vue&type=script&lang=js"
export * from "./NeoparentDashboardHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc38ed82",
  null
  
)

export default component.exports